// extracted by css-extract-rspack-plugin
export default {"footnotesItem":"OverviewTemplate-module__footnotesItem__fNAZe"};